// ===== Packages =====

import {
    getFunctions,
    httpsCallable,
}                               from 'firebase/functions';

// ===== Interfaces =====

import {
    IAnnotationItem,
}                               from '../interfaces';

const getAnnotationComments = async ({
    test,
    annotationId,
}: {
    test: boolean,
    annotationId: string,
}): Promise<Map<string, IAnnotationItem>> => {
    const REQUEST_TIMEOUT_MS = 8000;
    const functions = getFunctions();
    const handleGetAnnotationComments = httpsCallable<
        Record<
            string,
            boolean | string
        >,
        {
            [k: string]: IAnnotationItem,
        }
    >(
        functions,
        'getAnnotationComments',
    );
    const timeoutPromise = new Promise<never>((_, reject) => {
        setTimeout(() => {
            reject(new Error('Timed out fetching annotation comments.'));
        }, REQUEST_TIMEOUT_MS);
    });

    return Promise.race([
        handleGetAnnotationComments({
            test,
            annotationId,
        }),
        timeoutPromise,
    ]).then((result) => {
        const comments: Map<string, IAnnotationItem> = new Map(Object.entries(result.data));
        return comments;
    }).catch((err) => {
        throw err;
    });
};

export default getAnnotationComments;
